import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { EventLogMessageResponse } from '../dto/response/event-log-message-response';
import eventLoggingService from '../services/event-logging.service';
import { EventLogMessageResponseEventLogContextTypeEnum } from '../event-log-message-response-event-log-context-type-enum';
import { EventLogMessageResponseEventLogActionEnum } from '../event-log-message-response-event-log-action-enum';

const initialState = {
  status: 'idle',
  eventLogs: null as EventLogMessageResponse | null,
  filteredEventLogs: null as EventLogMessageResponse | null,
  eventLog: null as EventLogMessageResponse | null,
  error: null as string | null,
};

export const fetchEventLogs = createAsyncThunk(
  'eventLogging/fetchEventLogs',
  async () => {
    return await eventLoggingService.fetchEventLogs();
  }
);

interface FetchFilteredEventLogsParams {
  action?: string;
  contextType?: string;
  search?: string;
  fromDate?: string;
  toDate?: string;
}

export const fetchFilteredEventLogs = createAsyncThunk<
  EventLogMessageResponse,
  FetchFilteredEventLogsParams
>(
  'eventLogging/fetchEventLogs',
  async ({ action, contextType, search, fromDate, toDate }) => {
    return await eventLoggingService.fetchFilteredEventLogsService(
      action,
      contextType,
      search,
      fromDate,
      toDate
    );
  }
);

export const fetchEventLogsByContextType = createAsyncThunk(
  'eventLogging/fetchEventLogsByContextType',
  async (contextType: EventLogMessageResponseEventLogContextTypeEnum) => {
    return await eventLoggingService.fetchEventLogsByContextType(contextType);
  }
);

export const fetchEventLogsByAction = createAsyncThunk(
  'eventLogging/fetchEventLogsByAction',
  async (action: EventLogMessageResponseEventLogActionEnum) => {
    return await eventLoggingService.fetchEventLogsByAction(action);
  }
);

const eventLoggingSlice = createSlice({
  name: 'eventLoggingSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventLogs.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchEventLogs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.eventLogs = action.payload;
      })
      .addCase(fetchEventLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(fetchEventLogsByContextType.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchEventLogsByContextType.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.filteredEventLogs = action.payload;
      })
      .addCase(fetchEventLogsByContextType.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(fetchEventLogsByAction.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchEventLogsByAction.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.filteredEventLogs = action.payload;
      })
      .addCase(fetchEventLogsByAction.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default eventLoggingSlice.reducer;
